import { BidOffer } from "components/dataVisualization/DerivedData/useAcceptanceVolumeData";
import { BmuModel } from "models/bmuData/bmuModel";
import { DataDownloadFormat } from "models/dataDownload/dataDownloadFormat";
import {
  DataDownloadModel,
  JsonDataDownloadModel,
} from "models/dataDownload/dataDownloadModel";
import { IndicativeCashflowModel } from "models/derivedData/indicativeCashflow";

import { getIndicativeDerivedData } from "./utils";

export const getIndicativeCashflowData = async (
  settlementTime: Date,
  bidOffer: BidOffer,
  bmUnits?: BmuModel[],
  format?: DataDownloadFormat
): Promise<DataDownloadModel<IndicativeCashflowModel>> => {
  const baseUrl = "/balancing/settlement/indicative/cashflows/all";
  return getIndicativeDerivedData<IndicativeCashflowModel>(
    baseUrl,
    settlementTime,
    bidOffer,
    bmUnits,
    format
  );
};

export const getIndicativeCashflowJsonData = (
  settlementTime: Date,
  bidOffer: BidOffer,
  bmUnits?: BmuModel[]
): Promise<JsonDataDownloadModel<IndicativeCashflowModel>> =>
  getIndicativeCashflowData(
    settlementTime,
    bidOffer,
    bmUnits,
    DataDownloadFormat.Json
  ) as Promise<JsonDataDownloadModel<IndicativeCashflowModel>>;
